import React from 'react';
import { toast, ToastContainer } from 'react-toastify';

import CloseButton from './components/CloseButton';

export const TOAST_TYPES = toast.TYPE;

const activeToasts = [];

export const createToast = (message, type) => {
  if (activeToasts.indexOf(message) !== -1) {
    return null;
  }

  if (type === TOAST_TYPES.ERROR) {
    activeToasts.push(message);
  }

  const onCloseHandler = () => {
    if (type === TOAST_TYPES.ERROR) {
      const removeIndex = activeToasts.indexOf(message);
      activeToasts.splice(removeIndex, 1);
    }
  };

  return toast(message, {
    type,
    closeButton: CloseButton,
    position: 'top-center',
    onClose: onCloseHandler,
  });
};

const ToastWrapper = () => <ToastContainer enableMultiContainer />;

export default ToastWrapper;
